import api from './api'

export const enrollmentLinksApi = {
  getByTenant: async (tenantId) => {
    const response = await api.get(`/tenants/${tenantId}/enrollment-links`)
    return response.data
  },

  getByGroup: async (tenantId, groupId) => {
    const url = groupId
      ? `/tenants/${tenantId}/host-groups/${groupId}/enrollment-links`
      : `/tenants/${tenantId}/enrollment-links/root`
    const response = await api.get(url)
    return response.data // array
  },

  create: async (tenantId, data) => {
    const response = await api.post(`/tenants/${tenantId}/enrollment-links`, data)
    return response.data
  },

  update: async (id, data) => {
    const response = await api.put(`/enrollment-links/${id}`, data)
    return response.data
  },

  cancel: async (id) => {
    const response = await api.put(`/enrollment-links/${id}`, { isActive: false })
    return response.data
  },

  remove: async (id) => {
    await api.delete(`/enrollment-links/${id}`)
  },

  approve: async (agentId, data) => {
    const response = await api.post(`/internal/remote-hosts/${agentId}/approve`, data)
    return response.data
  },
}
